// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import '@styles/reset.css'//css样式重置
import '@styles/border.css'//css处理边框
import '@styles/iconfont/iconfont.css'//阿里iconfont
import '@styles/common.css'
import '@styles/generality.css'//公共css样式

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// // import './plugin/vconsole'// console
// import Vconsole from 'vconsole'
// new Vconsole()
import store from './store'// vuex
import 'lib-flexible'//处理px转换

import axios from 'axios'//axios
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

Vue.use(ElementUI);

import Vant from 'vant'//vant组件
import 'vant/lib/index.css'
Vue.use(Vant)

import Jc from '@/components/hzjc/index.js' // 自有组件库
Vue.use(Jc)

import VueAwesomeSwiper from 'vue-awesome-swiper'// swiper
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

// import fastClick from 'fastclick'//处理双击
// Vue.config.productionTip = false
// fastClick.attach(document.body)

import wx from '@/wx'//微信jsdk
import '@/plugin/img.js' //图片裁剪
Vue.prototype.$wx = wx

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

// 自定义指令
// 跳转指令
Vue.directive('link', {
  inserted: function(el, binding) {
    el.onclick = e=>{
      console.log(binding);
      e.stopPropagation()
      router.push(String(binding.value));
    }
  }
})

// 初始聚焦
Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

// 图片
Vue.directive('img', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el,bingding) {
    //规定尺寸
    let rules = bingding.value;
    //获取imgDOM
    let img = el;
    //2. 获取画布上下文
    img.onload = function(){
      //获取图片原始的宽高
      let imgWidth = img.naturalWidth;
      let imgHeight = img.naturalHeight;  
      let scale=rules.w/375;
      let dw =scale*document.body.clientWidth;
      let dh =rules.h;

      let showHeight=(dw/imgWidth)*imgHeight;
      img.style.position="absolute";
      img.style.top=(-showHeight+dh)/2+"px";
      img.style.width=dw+'px';
      img.style.clip = 'rect('+ (showHeight-dh)/2+'px '+dw+'px '+((showHeight-dh)/2+dh)+'px 0px)';
    }
  }
})

// 置顶按钮显示隐藏
Vue.directive('scroll-show',{
  inserted(el,binding){
    let scope = binding.arg || '200';
    window.addEventListener('scroll',function(e){
      if(this.scrollY > Number(scope)){
        binding.value.value = true;
      }else{
        binding.value.value = false;
      }
    })
  }
})

// 点击置顶
Vue.directive('back-top',{
  inserted(el,binding){
    let e = binding.arg || 'click';
    el.addEventListener(e,function(){
      let scrollToptimer = setInterval(function(){
        let top = document.documentElement.scrollTop + document.body.scrollTop;
        let speed = top/4;
        top -= speed;
        document.documentElement.scrollTop = document.body.scrollTop = top;
        if(top == 0){
          clearInterval(scrollToptimer);
        }
      },30)
    })
  }
})

// 全局方法
// post 交互
Vue.prototype.httpPost = function(initial) {
  return new Promise((resolve, reject) => {
    initial.loading=initial.loading||0;
    initial.params.user_id=localStorage.user_id;
    if(initial.loading){
        this.$toast.loading({
          forbidClick:true,
          message: '加载中...'
        });
    }
    Vue.axios.post('/wechat.php'+initial.url, initial.params).then(res => {
      this.$toast.clear(); 
      resolve(res.data)
    }).catch(res=>{
      this.$toast.clear();
      reject(res.data);
    })
  })
}


// fastClick.prototype.focus = function (targetElement) {
//   let length;
//   if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
//     length = targetElement.value.length;
//     targetElement.focus();
//     targetElement.setSelectionRange(length, length);
//   } else {
//     targetElement.focus();
//   }
// };


// WEBPACK FOOTER //
// ./src/main.js